import React from 'react';
import { useSiteContent } from '../context/SiteContentContext';

const Hero = () => {
  const { content, loading } = useSiteContent();

  const scrollToContact = () => {
    const element = document.querySelector('#povprasevanje');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (loading) {
    return (
      <section className="min-h-screen flex items-center justify-center bg-[#2D4A5E]">
        <div className="animate-pulse text-white text-xl">Nalaganje...</div>
      </section>
    );
  }

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={content.hero_background_image}
          alt="Anzo barvanje"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2D4A5E]/80 via-[#2D4A5E]/60 to-[#2D4A5E]/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto pt-20">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-4 leading-tight">
          <span className="text-white">{content.hero_title.split(' ').slice(0, -1).join(' ')} </span>
          <span className="text-[#4CAF50]">{content.hero_title.split(' ').slice(-1)}</span>
        </h1>
        
        <p className="text-white/90 text-lg md:text-xl mb-4 font-light">
          {content.hero_subtitle}
        </p>
        
        <p className="text-white/70 text-base md:text-lg mb-10 max-w-2xl mx-auto">
          {content.hero_description}
        </p>

        <button
          onClick={scrollToContact}
          className="bg-[#4CAF50] hover:bg-[#45a049] text-white font-semibold px-10 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl text-sm tracking-wide"
        >
          {content.hero_button_text}
        </button>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
